import type { EcomPromotion } from '../../../common/models/domain/ecommerce/promotion/promotion';

import { isEdlpPromotion } from '../../../common/models/domain/ecommerce/promotion/promotionMappers';
import EdlpPricingSplash from './EdlpPricingSplash';

type EdlpPriceBadgeProps = {
    promotion: EcomPromotion | undefined;
};

/** Small EDLP splash for listing `leadingBadgeSlot` (cart / search). */
const EdlpPriceBadge = ({ promotion }: EdlpPriceBadgeProps) =>
    isEdlpPromotion(promotion) ? <EdlpPricingSplash size="sm" /> : null;

export default EdlpPriceBadge;
